import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoRenavam } from './types';

export const INITIAL_STATE: impressaoRenavam = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoRenavam {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_RENAVAM_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_RENAVAM_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_RENAVAM_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_RENAVAM_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
